export const referenceFilterHasConditions = (value: string | null | undefined): boolean => {
    if (!value?.trim()) return false;
    try {
        const hasCondition = (node: any): boolean => Array.isArray(node)
            ? node.some(hasCondition)
            : node && typeof node === "object"
                ? node.type === "condition" ? Boolean(node.field && node.operator) : hasCondition(node.conditions)
                : false;
        return hasCondition(JSON.parse(value));
    } catch { return true; }
};
